var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-kiosk-devices",
                              title: _vm.getTitle
                                ? `Редактировать ${_vm.getTitle}`
                                : `Добавить киоск`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "PageContent",
                            { attrs: { height: "85" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Имя *")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "kioskName",
                                              outlined: "",
                                              autofocus: !_vm.fields.kioskName,
                                              "error-messages":
                                                _vm.validationErrors.kioskName,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.kioskName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "kioskName",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.kioskName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("wifi ssid")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.wifiSsid,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "wifiSsid",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.wifiSsid",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Api key *")]),
                                          _c("v-text-field", {
                                            staticClass:
                                              "v-text-field--mono-font",
                                            attrs: {
                                              id: "apiKey",
                                              readonly: "",
                                              outlined: "",
                                              "error-messages":
                                                _vm.validationErrors.apiKey,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.apiKey,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "apiKey",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.apiKey",
                                            },
                                          }),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                outlined: "",
                                                color: "primary",
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.generateKeys()
                                                },
                                              },
                                            },
                                            [_vm._v(" Сформировать api key ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Transport url")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value:
                                                _vm.fields.transportWidgetUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "transportWidgetUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fields.transportWidgetUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              outlined: "",
                                              label: "Активен",
                                              "error-messages":
                                                _vm.validationErrors.isActive,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.isActive,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "isActive",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.isActive",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              outlined: "",
                                              label: "Активен внешний монитор",
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value:
                                                _vm.fields
                                                  .isExternalMonitorActive,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "isExternalMonitorActive",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fields.isExternalMonitorActive",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-icon", {
                                            attrs: {
                                              color: _vm.data.isOnline
                                                ? "success"
                                                : "grey",
                                            },
                                            domProps: {
                                              textContent: _vm._s(
                                                "mdi-checkbox-marked-circle"
                                              ),
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.data.isOnline
                                                    ? "Онлайн"
                                                    : "Оффлайн"
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Расположение")]),
                                          _c("LocationAutocomplete", {
                                            attrs: {
                                              address: _vm.fields.location,
                                              loading:
                                                _vm.loading || _vm.disabled,
                                            },
                                            on: {
                                              "set-location": _vm.setLocation,
                                              "update-location-part":
                                                _vm.updateLocation,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("span", [
                                            _vm._v("Серийный номер *"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "serialNumber",
                                              outlined: "",
                                              "error-messages":
                                                _vm.validationErrors
                                                  .serialNumber,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.serialNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "serialNumber",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.serialNumber",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Логин трансляции *"),
                                          ]),
                                          _c("v-text-field", {
                                            staticClass:
                                              "v-text-field--mono-font",
                                            attrs: {
                                              readonly: "",
                                              outlined: "",
                                              id: "streamLogin",
                                              "error-messages":
                                                _vm.validationErrors
                                                  .streamLogin,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.streamLogin,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "streamLogin",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.streamLogin",
                                            },
                                          }),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                outlined: "",
                                                color: "primary",
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.generateKeys(
                                                    "streamLogin",
                                                    "string",
                                                    10,
                                                    12,
                                                    "login",
                                                    "abcdefghijklmnopqrstuvwxyz-_"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " Сформировать логин трансляции "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Пароль трансляции *"),
                                          ]),
                                          _c("v-text-field", {
                                            staticClass:
                                              "v-text-field--mono-font",
                                            attrs: {
                                              readonly: "",
                                              outlined: "",
                                              id: "streamPassword",
                                              "error-messages":
                                                _vm.validationErrors
                                                  .streamPassword,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.streamPassword,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "streamPassword",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fields.streamPassword",
                                            },
                                          }),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                outlined: "",
                                                color: "primary",
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.generateKeys(
                                                    "streamPassword",
                                                    "string",
                                                    6,
                                                    8,
                                                    "",
                                                    "abcdefghijklmnopqrstuvwxyz123456789-_"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " Сформировать пароль трансляции "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  !_vm.isNew
                                    ? _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [
                                                _vm._v("Stream url"),
                                              ]),
                                              _c("v-text-field", {
                                                staticClass:
                                                  "v-text-field--mono-font",
                                                attrs: {
                                                  outlined: "",
                                                  readonly: "",
                                                  loading: _vm.loading,
                                                  disabled: _vm.disabled,
                                                  value: _vm.fields.streamUrl,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("span", [_vm._v("Тип *")]),
                                          _c("v-select", {
                                            attrs: {
                                              outlined: "",
                                              id: "type",
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                              items: _vm.$options.kioskTypes,
                                              "error-messages":
                                                _vm.validationErrors.type,
                                              "item-text": "text",
                                              "item-value": "value",
                                            },
                                            model: {
                                              value: _vm.fields.type,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "type",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.type",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("FormKioskBannerType", {
                                    attrs: {
                                      requiredField: "",
                                      "banner-type": _vm.fields.bannerType,
                                      "loading-data": _vm.disabled,
                                      loading: _vm.loading,
                                      content:
                                        _vm.getBannerContent("bannerType"),
                                      title: "Тип рекламного баннера",
                                      errorBannerType:
                                        _vm.validationErrors.bannerType,
                                    },
                                    on: {
                                      "banner-type-change": function ($event) {
                                        _vm.fields.bannerType = $event
                                      },
                                      "update-content": function ($event) {
                                        return _vm.updateContent(
                                          "bannerType",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c("FormKioskBannerType", {
                                    attrs: {
                                      requiredField: "",
                                      "banner-type":
                                        _vm.fields.externalBannerType,
                                      "loading-data": _vm.disabled,
                                      loading: _vm.loading,
                                      content:
                                        _vm.getBannerContent(
                                          "externalBannerType"
                                        ),
                                      title:
                                        "Активировать дополнительный монитор",
                                      errorBannerType:
                                        _vm.validationErrors.externalBannerType,
                                    },
                                    on: {
                                      "banner-type-change": function ($event) {
                                        _vm.fields.externalBannerType = $event
                                      },
                                      "update-content": function ($event) {
                                        return _vm.updateContent(
                                          "externalBannerType",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    attrs: {
                      isNew: _vm.isNew,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "is-loading": _vm.loading,
                      "is-submit-disabled": _vm.disabled,
                      isLocales: false,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.data.id,
                      "entity-type": "kioskDevice",
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-kiosk")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-kiosk-devices" })
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("CityPicker", {
                                  attrs: {
                                    title: "Город",
                                    loading: _vm.loading || _vm.disabled,
                                  },
                                  model: {
                                    value: _vm.fields.cityId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fields, "cityId", $$v)
                                    },
                                    expression: "fields.cityId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("PlacePicker", {
                                  attrs: {
                                    title: "Место",
                                    loading: _vm.loading || _vm.disabled,
                                  },
                                  model: {
                                    value: _vm.fields.placeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fields, "placeId", $$v)
                                    },
                                    expression: "fields.placeId",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }